export default __webpack_public_path__ + "static/media/go-back-left.d4860b43.png";